const scrollObserver = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        scrollObserver.unobserve(entry.target);
      }
    });
  },
  { threshold: 0.1, rootMargin: '0px 0px -60px 0px' }
);

function initScrollAnimations(scope) {
  (scope || document).querySelectorAll('[data-animate]:not(.is-visible)').forEach((el) => {
    scrollObserver.observe(el);
  });
}

initScrollAnimations();

// Re-observe after Shopify editor re-renders a section
document.addEventListener('shopify:section:load', (e) => initScrollAnimations(e.target));
document.addEventListener('shopify:section:reorder', () => initScrollAnimations());
document.addEventListener('shopify:block:select', (e) => initScrollAnimations(e.target));
